module.exports = __webpack_public_path__ + "static/img/boat-7.5676839.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/boat-7.png
// module id = N+KC
// module chunks = 0